/**
 * A single product/level contained in a burned license (the `license` array
 * items returned by the core's `license/user/burned-licenses` endpoint). Same
 * contract Tekman Digital uses.
 */
export interface LicenseProduct {
  /** License identifier. */
  tkmId: string;
  /** Program / platform id, e.g. `ONMAT` or `EMAT`. */
  programId: string;
  /** Level, e.g. `ESO1`. */
  level: string;
  /** Educational stage, e.g. `Secundaria` (may be null). */
  stage: string | null;
  /** Language code, e.g. `ESP`. */
  language: string;
  /** Edition, e.g. `latest`. */
  edition: string;
  /** Subprogram, e.g. `ONMAT`. */
  subprogram: string;
  /** Display name of the product. */
  productName: string;
  /** Product type, e.g. `digital`. */
  productType: string;
  /** Material path, e.g. `onmat`. */
  materialPath: string;
  /** `1` when the license is digital. */
  digital: number;
}

/**
 * A license already burned/activated by the authenticated user, as returned by
 * `license/user/burned-licenses`. The concrete products live in the nested
 * `license` array.
 */
export interface BurnedLicense {
  /** Activation code (Tekman Digital License). */
  tdl: string;
  /** License identifier. */
  tkmId: string;
  /** Academic year, e.g. `2026`. */
  year: number;
  /** Activation timestamp, e.g. `2026-08-28 08:05:19`. */
  burnedAt: string;
  /** Activation status, e.g. `resolved`. */
  status: string;
  /** Products/levels granted by this license. */
  license: LicenseProduct[];
}
